<mat-accordion [id]="'navitems'" 
    cdkDropList 
    [cdkDropListData]="definitions" 
    (cdkDropListDropped)="drop($event)"
    *ngIf="definitions as navitems">

    <ng-container *ngFor='let nav of navitems'>
        <ng-template [ngIf]="nav.children.length>0" [ngIfElse]="singlelink">
            <mat-expansion-panel cdkDrag [cdkDragDisabled]='!isEditable' id="{{nav.ID}}">
                <mat-expansion-panel-header>
                    <ng-template [ngIf]="isRoute(nav.route)" [ngIfElse]='link'>
                        <button mat-menu-item [routerLink]="[nav.route]">
                            <mat-icon color="primary" [aria-label]="nav.title">{{nav.img}}</mat-icon>
                            <span id="title{{nav.title}}">{{nav.title}}</span>
                        </button>
                    </ng-template>
                    <ng-template #link>
                        <a mat-menu-item [href]="nav.route" appUrl>
                            <mat-icon color="primary" [aria-label]="nav.title">{{nav.img}}</mat-icon>
                            <span id="title{{nav.title}}">{{nav.title}}</span>
                        </a>
                    </ng-template>
                </mat-expansion-panel-header>

                <mat-accordion *ngIf="nav.children.length>0" [id]="'child-'+nav.ID" cdkDropList
                    [cdkDropListData]="nav.children" (cdkDropListDropped)="drop($event)">
                    <div class="indented" cdkDrag [cdkDragDisabled]="!isEditable" id="{{kids.ID}}" *ngFor='let kids of nav.children'>
                        <ng-template [ngIf]="isRoute(kids.route)" [ngIfElse]='sublink'>
                            <button mat-menu-item [routerLink]="[kids.route]">
                                <mat-icon color="primary" aria-labelledby="title{{kids.title}}">{{kids.img}}</mat-icon><span
                                    id="title{{kids.title}}">{{kids.title}}</span>
                            </button>
                        </ng-template>

                        <ng-template #sublink>
                            <a mat-menu-item [href]="kids.route" appUrl>
                                <mat-icon  color="primary" aria-labelledby="title{{kids.title}}">{{kids.img}}</mat-icon>
                                <span id="title{{kids.title}}">{{kids.title}}</span>
                            </a>
                        </ng-template>
                    </div>
                </mat-accordion>
            </mat-expansion-panel>
        </ng-template>
        
        <ng-template #singlelink>
            <ng-template [ngIf]="isRoute(nav.route)" [ngIfElse]='link'>
                <button mat-menu-item [routerLink]="[nav.route]">
                    <mat-icon  color="primary" [aria-label]="nav.title">{{nav.img}}</mat-icon>
                    <span id="title{{nav.title}}">{{nav.title}}</span>
                </button>
            </ng-template>
            <ng-template #link>
                <a mat-menu-item [href]="nav.route" appUrl>
                    <mat-icon  color="primary" [aria-label]="nav.title">{{nav.img}}</mat-icon>
                    <span id="title{{nav.title}}">{{nav.title}}</span>
                </a>
            </ng-template>
            
        </ng-template>
    </ng-container>
</mat-accordion>